import { CLASS_NAMES, EVENTS } from '@bs/constants';
import { MessageBus } from '@bs/utils';

/**
 * A class for the LinkListing module
 */
export default class LinkListing extends MessageBus {
  /**
   * Constructor function for the LinkListing class.
   * @param {HTMLElement} element - REQUIRED - the module's container
   */
  constructor(element) {
    super();
    this.element = element;
    this.scrollRaf = null;
    this.isAlreadyAnimated = false;

    this.init();
  }

  /**
   * Initializes the view
   * @returns {LinkListing} - A reference to the current instance of the class
   */
  init() {
    this.cacheDomReferences().setupHandlers().enable();
    return this;
  }

  /**
   * Cache DOM References
   * @returns {LinkListing} - A reference to the current instance of the class
   */
  cacheDomReferences() {
    this.container = this.element;
    this.items = this.container.querySelectorAll(`
      .${CLASS_NAMES.LINK_LISTING_ITEM}`);

    return this;
  }

  /**
   * Bind event handlers to the correct context
   * @returns {LinkListing} - A reference to the current instance of the class
   */
  setupHandlers() {
    this.onScroll = this.onScroll.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
    return this;
  }

  /**
   * Enable event listeners
   * @returns {LinkListing} - A reference to the current instance of the class
   */
  enable() {
    // if (!this.container || !this.items.length) return this;

    window.addEventListener(EVENTS.SCROLL, this.onScroll);
    this.onScroll(); // Run once on load
    return this;
  }

  /**
   * Remove event listeners and clean up
   */
  destroy() {
    window.removeEventListener(EVENTS.SCROLL, this.onScroll);
    if (this.scrollRaf) {
      cancelAnimationFrame(this.scrollRaf);
    }
  }

  /**
   * Throttle scroll with requestAnimationFrame
   */
  onScroll() {
    if (this.scrollRaf) return;
    this.scrollRaf = requestAnimationFrame(this.handleScroll);
  }

  /**
   * Handle scroll logic
   */
  handleScroll() {
    if (this.isAlreadyAnimated) return;

    this.scrollRaf = null;

    const containerRect = this.container.getBoundingClientRect();
    const isContainerInView =
      containerRect.top + 300 < window.innerHeight && containerRect.bottom > 0;

    if (!isContainerInView) return;

    this.container.classList.add(CLASS_NAMES.IS_IN_VIEWPORT);

    this.isAlreadyAnimated = true;
  }
}
